import { Alert, Button, Card, Col, Form, Input, Modal, notification, Popover, Row, Select, Tag, Tooltip } from 'antd'
import { useEffect, useState } from 'react';
import CookieService from "encrypted-cookie";
import secureLocalStorage from "react-secure-storage";
import { useParams } from 'react-router-dom';
import { avoidIngredientByClientApi, editMedicalDataApi, editPatientRoutineDietApi, listOfPatientRoutineDietApi, listOfRecipeTagsApi, listOfTagApi, updateMedicalDataApi } from '../../../../../../../config/Api';
import { API_ERR_MESSAGE } from '../../../../../../../config/constant';
import { FilterApiData } from '../../../../../../../services/FilterApiData';
import { ageFromDob } from '../../../../../../../services/BirthDate';
import { BmiLevelTags } from '../../../../../../../components/BmiLevelTags';
import { IngredientAvoidByClient } from './IngredientAvoidByClient';

export const PatientDetailForm = (props) => {
    const userData = props.patientData
    // const { age, gender, mobile } = props.patientData
    const [form] = Form.useForm();
    const { Option } = Select;
    const { id } = useParams();

    // const [patientData, setPatientData] = useState();
    const [optionsSelected, setOptionsSelected] = useState([]);
    const [allergiesOptionsSelected, setAllergiesOptionsSelected] = useState([]);
    const [tagsList, setTagsList] = useState([]);
    const [allergyTagsList, setAllergyTagsList] = useState([]);
    const [allergiesTagsList, setAllergiesTagsList] = useState([]);
    const [presentMedicalProblems, setPresentMedicalProblems] = useState([]);
    const [avoidIngredientsList, setAvoidIngredientsList] = useState([]);
    const [patientMedicalData, setPatientMedicalData] = useState({});
    const [showErr, setShowErr] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false)

    useEffect(() => {
        // setPatientData(props?.patientData)
        // console.log('l', props?.patientData);
    }, [props?.patientData])

    const onFinish = (values) => {
        // console.log(values);
        const apiData = {
            "flag": "true",
            "food_preference": values.food_preference,
            "preferred_time": JSON.stringify(values.preferred_time),
            "diet_remark": values.remark,
            "patient_id": id
        }
        // console.log(apiData);
        // console.log(patientMedicalData);
        // user need to fill medical detail tab page data first then and then thos form data can save
        if (Object.entries(patientMedicalData).length == 0) {
            // console.log("cc");
            setShowErr(true)
        }
        // we call update api of medical data 
        if (Object.entries(patientMedicalData).length > 0) {
            updateMedicalDataApi(patientMedicalData.id, apiData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Patient Medical Data update successfully",
                        });
                        // getPatientMedicalData()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }

    };
    const resetData = () => {
        form.resetFields()
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    // const PreferredTimeOptions = [
    //     { id: '1', name: "8AM - 9 AM" },
    //     { id: '2', name: "9 AM - 10 AM" },
    //     { id: '3', name: "10 AM - 11AM" },
    //     { id: '4', name: "11 AM - 12 PM" },
    //     { id: '5', name: "12 PM - 1 PM" },
    //     { id: '6', name: "1 PM - 2 PM" },
    // ];
    const PreferredTimeOptions = [
        { id: '1', name: "3 Meal" },
        { id: '2', name: "4 Meal" },
        { id: '3', name: "5 Meal" },
        { id: '4', name: "6 Meal" },
    ];
    const AllergiesOptions = [
        { id: '1', name: "8AM - 9 AM" },
        { id: '2', name: "9 AM - 10 AM" },
        { id: '3', name: "10 AM - 11AM" },
        { id: '4', name: "11 AM - 12 PM" },
        { id: '5', name: "12 PM - 1 PM" },
        { id: '6', name: "1 PM - 2 PM" },
    ];

    const handleChange = value => {
        // console.log(`selected ${value}`);
        setOptionsSelected(value);
    };
    const handeAllergies = value => {
        // console.log(`selected ${value}`);
        setAllergiesOptionsSelected(value);
    };

    // get the list of all Tags
    const getListOfTags = () => {
        listOfTagApi({ "patient_id": parseInt(id) })
            .then((res) => {
                if (res.status === 200) {
                    setTagsList(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    const getListOfRecipeTags = () => {
        listOfRecipeTagsApi()
            .then((res) => {
                if (res.status === 200) {
                    const tempData = FilterApiData(res.data.data)
                    if (tempData.length > 0) {
                        const updatedData = tempData.filter((element) => element.tagType == "Allergy Tags")
                        setAllergyTagsList(updatedData);
                    }
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }


    // get the list of ingredient to avoid by client base on their present medical problems
    //===========================
    const getavoidIngredientForClient = () => {
        // console.log(presentMedicalProblems);

        let arrayOfpresentMedicalProblemsTagId;

        // create an array of its ids to pass and get list of avoid ingredient 
        if (presentMedicalProblems && presentMedicalProblems.length > 0) {
            arrayOfpresentMedicalProblemsTagId = presentMedicalProblems.filter((medicalRecord) => medicalRecord).map(elemnt => elemnt.tag_id)
            const data = {
                "tag_ids": arrayOfpresentMedicalProblemsTagId
            }
            avoidIngredientByClientApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        setAvoidIngredientsList(res.data.data)
                        // notification.success({
                        //     message: "avoid Ingredient By Client callled",
                        // });
                        setIsModalVisible(true)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        } else {
            setIsModalVisible(true)

        }
    }

    useEffect(() => {

    }, [showErr])

    // get Patient Medical Data and fill it if available  
    const getPatientMedicalData = () => {
        editMedicalDataApi(id)
            .then((res) => {
                if (res.status === 200) {
                    let medicalData = res.data.data
                    let selectedOption = []
                    let medicalProblems = []
                    if (medicalData) {
                        setPatientMedicalData(medicalData)
                        // console.log(medicalData);
                        medicalData?.medical_history_tag_list?.map((tagData) => {
                            tagData.tag_type == "allergy_tag" && selectedOption.push(tagData)
                            tagData.tag_type == "present_medical_problem" && medicalProblems.push(tagData)
                        })
                        setAllergiesTagsList(selectedOption)
                        setPresentMedicalProblems(medicalProblems)
                        form.setFieldsValue({
                            "food_preference": medicalData?.food_preference,
                            "preferred_time": JSON.parse(medicalData?.preferred_time) || [],
                            "remark": medicalData?.diet_remark,
                        })
                        // console.log("md", medicalProblems);
                    }
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    useEffect(() => {
        // to get the details of all allergies tags
        getPatientMedicalData()

        getListOfTags()
        getListOfRecipeTags()

        // cookie encryption
        CookieService.setCookie("userName", "Bavaram", 7, "aaa");
        // console.log(CookieService.getCookie("userName", "aaa"));

        // local storage encryption data
        secureLocalStorage.setItem("object", {
            message: "This is testing of local storage",
        });
        // console.log(secureLocalStorage.getItem("object"))

    }, []);

    // on below states data value change call api again
    useEffect(() => {
        getListOfTags()

    }, [props?.tagData]);

    const [loading, setLoading] = useState(false)
    const [editDietFormData, setEditDietFormData] = useState({})
    const [patientData, setPatientData] = useState({})


    const getExistPatientRoutineDietDetails = () => {
        setLoading(true)

        editPatientRoutineDietApi(id)
            .then((res) => {
                if (res.status === 200) {
                    const data = res.data?.[0]
                    if (data) {
                        let formattedTimeRanges = []
                        // console.log("edit data", data);
                        // const stringData = "{\"12:00 AM to 01:00 AM\"}";
                        if (data?.preferred_meal_time) {

                            const stringData = data?.preferred_meal_time;

                            // Removing curly braces at the beginning and end of the string
                            const dataWithoutBraces = stringData.slice(1, -1);

                            // Splitting the string by commas
                            const timeRangesArray = dataWithoutBraces.split(',');

                            // Using map to strip whitespace and quotation marks from each element
                            formattedTimeRanges = timeRangesArray.map(timeRange => {
                                return timeRange.trim().slice(1, -1);
                            });
                        }

                        let updatedData = {
                            'preferred_meal_pattern': data?.preferred_meal_pattern,
                            'food_preference': data?.food_preference,
                            'preferred_meal_time': formattedTimeRanges,
                            'items_to_be_avoided': data?.items_to_be_avoided,
                        }
                        setPatientData(updatedData)
                    }

                    setEditDietFormData(data)
                }
                setLoading(false)
            })
            .catch((err) => {
                console.log(err);
                notification.error({
                    message: API_ERR_MESSAGE,
                });
                setLoading(false)
            });
    }

    useEffect(() => {
        getExistPatientRoutineDietDetails()
    }, [])
    // console.log("ppdata", patientData);

    return (
        <Form
            name="AddPatientDetailForm"
            className="AddPatientDetail"
            form={form}
            layout="horizontal"
            onFinish={onFinish}
        >

            <Row className='PatientDetailCard'>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} >
                    <Card title={props?.patientData?.name} className='userPofileCard'>
                        <Row>
                            <Col span={12}>
                                <h6>Age  :</h6>
                            </Col>
                            <Col span={12}>
                                {/* <p>{patientData?.age && patientData?.age + 'Years'} </p> */}
                                <p>{ageFromDob(props?.patientData?.dob) !== null && ageFromDob(props?.patientData?.dob) + "  Years"} </p>
                            </Col>
                            <Col span={12}>
                                <h6>BMI  :</h6>
                            </Col>
                            <Col span={12}>
                                <p>
                                    {parseFloat(props?.patientData?.bmi) > 0 && parseFloat(props?.patientData?.bmi)}
                                    <br />
                                    <BmiLevelTags bmi={props?.patientData?.bmi} />
                                </p>
                            </Col>
                            <Col span={12}>
                                <h6>Gender :</h6>
                            </Col>
                            <Col span={12}>
                                <p>{props?.patientData?.gender}</p>
                            </Col>
                            <Col span={12}>
                                <h6>Phone  :</h6>
                            </Col>
                            <Col span={12}>
                                <p>{userData?.mobile}</p>
                            </Col>
                            <Col span={12}>
                                <h6>Program  :</h6>
                            </Col>
                            <Col span={12}>
                                <p>{props?.patientData?.program?.name}</p>
                            </Col>
                            <Col span={12}>
                                <h6>Health Goal  :</h6>
                            </Col>
                            <Col span={12}>
                                <p>{props?.patientData?.program?.health_focus_area?.name}</p>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col xs={24} md={12} lg={12} xl={8} xxl={8} >
                    <Card title="NOTES">
                        {/* the Notes field from Medical Details */}
                        {patientMedicalData?.remark
                            ? <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{patientMedicalData.remark}</p>
                            : <p className="mb-0 text-muted">No notes yet</p>}
                        <hr className='p-0' />
                        <Button type="link" onClick={() => props.onChange("2")}>Edit notes in Medical Details</Button>
                    </Card>
                </Col>
                <Col xs={24} md={12} lg={12} xl={8} xxl={8} >
                    <Card title="INGREDIENTS ABSTINENCE" >
                        {/* "Items to be Avoided" from Medical Details > Routine Diet */}
                        {editDietFormData?.items_to_be_avoided
                            ? <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{editDietFormData.items_to_be_avoided}</p>
                            : <p className="mb-0 text-muted">Nothing added yet</p>}
                        <hr className='p-0' />
                        <Button type="link" onClick={() => getavoidIngredientForClient()}>View list of ingredients to be avoided</Button>
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className='AddPatientDetailForm'>
                <Col xs={24} md={16} xl={24} xxl={24} className="align-self-center">
                    {showErr && <Alert onClose={() => setShowErr(false)} message="Please Provide Medical Detail Tab Information First" type="error" showIcon closable />}
                </Col>
                <Col xs={24} md={16} xl={24} xxl={24} className="align-self-center">
                    <div className='tagList'>
                        <label className="form-input-label me-2">
                            Tags:
                        </label>
                        {tagsList && tagsList.length > 0 ? tagsList.map((tagData, index) =>
                            <Tooltip className='w-25' title={tagData?.note}> <Tag onClick={() => props.onChange("7")}>{tagData?.tag}</Tag></Tooltip>
                        )
                            :
                            <Tag>None</Tag>
                        }
                    </div>
                </Col>
                <Col xs={24} md={8} xl={24} xxl={24} className="align-self-center">
                    <div className='tagList'>
                        <label className="form-input-label me-2">
                            Allergy Tags:
                        </label>
                        {allergiesTagsList && allergiesTagsList.length > 0 ? allergiesTagsList.map((tagData, index) =>
                            <Tag key={index}>{tagData?.recipe_tag?.name}</Tag>
                        )
                            :
                            <Tag>None</Tag>
                        }
                    </div>
                </Col>
                <Col xs={24} md={8} xl={6} xxl={6} className="align-self-center d-flex align-items-center">
                    <label className="form-input-label mb-1 me-3">
                        Program Name:
                    </label>
                    <Form.Item
                        className='mb-0 h5'
                        name="program_name"
                    >
                        {props?.patientData?.program?.name}
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={6} xxl={6} className="align-self-center d-flex align-items-center">
                    <label className="form-input-label mb-1 me-3">
                        Plan Starts :
                    </label>
                    <Form.Item
                        className='mb-0 h5'
                        name="plan_start"
                    >
                        {props?.patientData?.start_date}
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={6} xxl={6} className="align-self-center d-flex align-items-center">
                    <label className="form-input-label mb-1 me-3">
                        Plan Ends :
                    </label>
                    <Form.Item
                        className='mb-0 h5'
                        name="plan_ends"
                    >
                        {props?.patientData?.end_date}
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={6} xxl={6} className="align-self-center d-flex align-items-center">
                    <label className="form-input-label mb-1 me-3">
                        Medical Problem:
                    </label>
                    {presentMedicalProblems && presentMedicalProblems.length > 0 ? presentMedicalProblems.map((tagData, index) =>
                        <Tag key={index}>{tagData?.recipe_tag?.name}</Tag>
                    )
                        :
                        <Tag>None</Tag>
                    }
                </Col>
                <Col xs={24} md={16} xl={6} xxl={6} className="">
                    <label className="form-input-label">
                        Meal Pattern
                        {/* <span className="asterik"> *</span> */}
                    </label>
                    <p>
                        {patientData?.preferred_meal_pattern ? patientData?.preferred_meal_pattern : ''}
                    </p>

                    {/* <Form.Item
                        name="food_preference"
                        rules={[
                            { required: true, message: "Please Select Food Preference!" },
                        ]}
                        initialValue=""
                    > */}
                    {/* <Select
                            className="mt-2"
                        // value={regType}
                        // defaultValue=""
                        // onChange={(e) => setRegType(e)}
                        >
                            <Option value="" disabled hidden>
                                Select Food Preference
                            </Option>
                            <Option value="Vegetarian">Vegetarian</Option>
                            <Option value="Non-Vegetarian">Non-Vegetarian</Option>
                            <Option value="Eggtarian">Eggtarian</Option>
                        </Select> */}
                    {/* </Form.Item> */}
                </Col>
                {/* <Col xs={24} md={16} xl={6} xxl={6} className="align-self-center">
                    <label className="form-input-label">
                        Allergies
                    </label>
                    <Form.Item
                        name="allergies"
                        rules={[
                            { required: true, message: "Please Select Allergies!" },
                        ]}
                        initialValue=""
                    >
                        <Select
                            allowClear
                            showSearch
                            filterOption={(inputValue, option) =>
                                option.children.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            onChange={handeAllergies}
                            // defaultValue=""
                            maxTagCount="responsive"
                            mode="multiple"
                            placeholder="Select Allergies"
                        >
                            <Option value="" disabled>Select Maximum 5 Allergies</Option>
                            {allergyTagsList && allergyTagsList.length > 0 && allergyTagsList.map(option => (
                                <Option disabled={
                                    allergiesOptionsSelected.length > 5
                                        ? allergiesOptionsSelected.includes(option)
                                            ? false
                                            : true
                                        : false
                                } key={option.id}>{option.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col> */}
                <Col xs={24} md={16} xl={6} xxl={6} className="align-self-center">
                    <label className="form-input-label">
                        Preferred Time
                        {/* <span className="asterik"> *</span> */}
                    </label>
                    <p>
                        {patientData?.preferred_meal_time && patientData?.preferred_meal_time?.length > 0 ?
                            patientData?.preferred_meal_time?.map(record =>
                                <p style={{ marginBottom: "0" }}>
                                    {record},
                                </p>
                            ) :
                            ''}
                    </p>
                    {/* <Form.Item
                        name="preferred_time"
                        rules={[
                            { required: false, message: "Please Preferred Time!" },
                            // {
                            //     validator: async (_, value) => {
                            //       if (value.length < 3) {
                            //         return Promise.reject('Please select at least 3 options');
                            //       } else if (value.length > 5) {
                            //         return Promise.reject('You can select up to 5 options');
                            //       }
                            //       return Promise.resolve();
                            //     },
                            //   },
                        ]}
                    // initialValue=""
                    > */}
                    {/* <Select
                            showSearch
                            filterOption={(inputValue, option) =>
                                option.children.toLowerCase().includes(inputValue.toLowerCase())
                            }
                            placeholder="Select Preferred Time"
                        >
                            {PreferredTimeOptions.map(option => (
                                <Option
                                    value={option.name} key={option.id}>{option.name}</Option>
                            ))}
                        </Select> */}
                    {/* </Form.Item> */}
                </Col>
                <Col xs={24} md={16} xl={6} xxl={6} className="">
                    <label className="form-input-label">
                        Food Preference
                        {/* <span className="asterik"> *</span> */}
                    </label>
                    <p>
                        {patientData?.food_preference ? patientData?.food_preference : ''}
                    </p>
                    {/* <Form.Item
                        name="remark"
                        rules={[
                            { required: false, message: "Please Insert Remark !" },
                        ]}
                    >
                        <Input.TextArea placeholder="Description" className="p-1" rows={2} />
                    </Form.Item> */}
                </Col>
                {/* <Col xs={24} md={24} xl={24} xxl={24} className=" align-self-center text-center">
                    <Button
                        // disabled={patientMedicalData ? "false" : "true"} 
                        htmlType="submit" className="submit-button b-0 rounded">
                        SAVE
                    </Button>
                </Col> */}
            </Row>

            <Modal
                open={isModalVisible}
                // centered
                footer={null}
                title="Ingredients to be Avoided by Client"
                width={900}
                className="notRecomandedListModal"
                onCancel={handleCancel}
            >
                <IngredientAvoidByClient
                    avoidIngredientsList={avoidIngredientsList}
                />
            </Modal>
        </Form >
    )
}
